import React, { useState } from "react";
import "./PaywallPage.css";
import { Link } from "react-router-dom";
import backIcon from "./icons/keyboard_backspace-24px.svg";
import { loadStripe } from "@stripe/stripe-js";
import CreateStripeSessionMutation from "./mutations/stripe-mutations/CreateStripeSessionMutation";
import { useTheme } from "./contexts/ThemeContext";
import tickIcon from "./icons/tick_icon.svg";
import { useNavigate } from "react-router-dom";
import {
    CURRENCY_CODES,
    SUPPORTED_CURRENCIES,
    stripeUnitPrice,
    getNativePrice,
} from "./data/currency_codes";

const {
    REACT_APP_STRIPE_PUBLIC_KEY,
    REACT_APP_PRICE_ID_MONTHLY,
    REACT_APP_PRICE_ID_YEARLY,
    REACT_APP_PRICE_YEARLY_DOLLARS,
    REACT_APP_PRICE_MONTHLY_DOLLARS,
} = process.env;

const stripePromise = loadStripe(REACT_APP_STRIPE_PUBLIC_KEY);
const monthlyPriceId = REACT_APP_PRICE_ID_MONTHLY;
const yearlyPriceId = REACT_APP_PRICE_ID_YEARLY;

function PaywallPage(props) {
    const { is_premium, currency } = props.user;
    const theme = useTheme();
    const navigate = useNavigate();

    let monthlyPrice = getNativePrice(
        currency,
        REACT_APP_PRICE_MONTHLY_DOLLARS,
        "month"
    );
    let annualPrice = getNativePrice(
        currency,
        REACT_APP_PRICE_YEARLY_DOLLARS,
        "year"
    );
    let annualPricePerMonth =
        Math.round(((annualPrice + Number.EPSILON) / 12) * 10) / 10;

    let stripeMonthlyPrice = stripeUnitPrice(currency, monthlyPrice);
    let stripeAnnualPrice = stripeUnitPrice(currency, annualPrice);

    function formatPriceString(amount, currency) {
        let usNumberLocale = Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
        });
        return usNumberLocale.format(amount);
    }

    const monthlyDisplayPrice =
        formatPriceString(monthlyPrice, currency) + "/mo";
    const yearlyDisplayPrice =
        formatPriceString(annualPricePerMonth, currency) + "/mo";

    const onMonthlyCheckoutButtonClick = async (e) => {
        e.preventDefault();
        const stripe = await stripePromise;
        CreateStripeSessionMutation(
            monthlyPriceId,
            currency,
            stripeMonthlyPrice,
            "month",
            false,
            (sessionId) => {
                console.log(sessionId);
                if (sessionId != null) {
                    const result = stripe.redirectToCheckout({
                        sessionId: sessionId,
                    });
                }
            }
        );
    };

    const onYearlyCheckoutButtonClick = async (e) => {
        e.preventDefault();
        const stripe = await stripePromise;
        CreateStripeSessionMutation(
            yearlyPriceId,
            currency,
            stripeAnnualPrice,
            "year",
            false,
            (sessionId) => {
                if (sessionId != null) {
                    const result = stripe.redirectToCheckout({
                        sessionId: sessionId,
                    });
                }
            }
        );
    };

    const onTrialButtonClick = async (e) => {
        e.preventDefault();
        const stripe = await stripePromise;
        CreateStripeSessionMutation(
            yearlyPriceId,
            currency,
            stripeAnnualPrice,
            "year",
            true,
            (sessionId) => {
                if (sessionId != null) {
                    const result = stripe.redirectToCheckout({
                        sessionId: sessionId,
                    });
                }
            }
        );
    };

    return (
        <div className={`paywall-page-wrapper theme-${theme.light}`}>
            <div
                className={`settings-header header header-fixed-true theme-${theme.dark}`}
            >
                <div
                    className={`paywall-settings-header-room paywall-header-room-true theme-${theme.light}`}
                >
                    <div className={`settings-header-controls`}>
                        <Link to="/home">
                            {" "}
                            <img className="back-icon" src={backIcon} />{" "}
                        </Link>
                    </div>
                </div>
            </div>
            <div className="paywall-container">
                <div className="free-trial-button-container">
                    <button
                        onClick={onTrialButtonClick}
                        className="trial-btn"
                    >
                        {" "}
                        Try Free
                    </button>
                    <p className="cancel-anytime">
                        * Cancel Anytime. <mark>You won't be charged for 7 days.</mark>
                    </p>
                </div>
                <div className={`paywall-body theme-${theme.paragraph}`}>
                    <div className="basic-category">
                        <div className="category-title">
                            <h3>{"Basic"}</h3>
                            <h2 className={`theme-${theme.paragraph}`}>
                                Lifetime Free
                            </h2>
                            <h2></h2>
                        </div>
                        <div className={`pricing`}>
                            {" "}
                            <h3 className="price"> Free </h3>{" "}
                        </div>
                        <div className="feature-list">
                            <ul>
                                <li>
                                    {" "}
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className={`feature-item`}>
                                        Read, Save and Share articles
                                    </span>
                                </li>
                                <li>
                                    {" "}
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span>Upto 150 subscriptions</span>{" "}
                                </li>{" "}
                                <li>
                                    {" "}
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span>Basic Search</span>{" "}
                                </li>{" "}
                            </ul>
                        </div>
                    </div>

                    <div className="premium-annual-category">
                        <div
                            className={`category-title theme-${theme.paragraph}`}
                        >
                            <h3 className="price">{"Premium"}</h3>
                            <h2 className={`theme-${theme.paragraph}`}>
                                Annual Membership
                            </h2>
                        </div>

                        <div className={`pricing`}>
                            <h3 className="price">{yearlyDisplayPrice}</h3>
                            <p>Billed Annually</p>
                            <h3 className="offer">25% OFF</h3>
                        </div>
                        <div className="feature-list">
                            <ul>
                                <li>
                                    {" "}
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className={`feature-item`}>
                                        Read, Save and Share articles
                                    </span>
                                </li>
                                <li>
                                    {" "}
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    Upto 1000 subscriptions{" "}
                                </li>{" "}
                                {/* <li>
                  {" "}
                  <span className={`tick-mark`}>
                    <img src={tickIcon} alt="" />
                  </span>
                  <span>Search Articles</span>{" "}
                </li>{" "} */}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-topic-analysis feature-highlight">
                                        Topic Analytics
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        Sentimental Trends{" "}
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        Advanced Search
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        One-click Summarisation{" "}
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    Save to Instapaper & Pocket{" "}
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    Share via LinkedIn{" "}
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        Rich Text Notes{" "}
                                    </span>
                                </li>{" "}
                            </ul>
                        </div>
                        <div>
                            <button
                                id="checkout-buttton"
                                // className="standard-action-button"
                                className="plan-upgrade-btn"
                                onClick={onYearlyCheckoutButtonClick}
                            >
                                {" "}
                                Upgrade
                            </button>
                        </div>
                    </div>

                    <div className="premium-monthly-category">
                        <div className="category-title">
                            <h3>Premium</h3>
                            <h2 className={`theme-${theme.paragraph}`}>
                                Monthly Membership
                            </h2>
                        </div>
                        <div className={`pricing`}>
                            <h3 className="price">{monthlyDisplayPrice}</h3>
                            <p>Billed Monthly</p>
                        </div>

                        <div className="feature-list monthly-feature-list">
                            <ul>
                                <li>
                                    {" "}
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className={`feature-item`}>
                                        Read, Save and Share articles
                                    </span>
                                </li>
                                <li>
                                    {" "}
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    Upto 1000 subscriptions{" "}
                                </li>{" "}
                                {/* <li>
                  {" "}
                  <span className={`tick-mark`}>
                    <img src={tickIcon} alt="" />
                  </span>
                  <span>Search Articles</span>{" "}
                </li>{" "} */}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-topic-analysis feature-highlight">
                                        Topic Analytics
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        Sentimental Trends{" "}
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        Advanced Search{" "}
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        One-click Summarisation{" "}
                                    </span>
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    Save to Instapaper & Pocket{" "}
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    Share via LinkedIn{" "}
                                </li>{" "}
                                <li>
                                    <span className={`tick-mark`}>
                                        <img src={tickIcon} alt="" />
                                    </span>
                                    <span className="feature-highlight">
                                        Rich Text Notes{" "}
                                    </span>
                                </li>{" "}
                            </ul>
                        </div>

                        <div>
                            <button
                                id="checkout-buttton"
                                // className="standard-action-button"
                                className="plan-upgrade-btn"
                                onClick={onMonthlyCheckoutButtonClick}
                            >
                                {" "}
                                Upgrade
                            </button>
                        </div>
                    </div>

                    <div>
                        {/* <button
            onClick={onYearlyCheckoutButtonClick}
            className="free-trial-btn"
          >
            {" "}
           Start Free Trial 
          </button> */}
                        {/* Cancel Any time. */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaywallPage;
